import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { useReduxState } from "../redux/hooks";
import { Label } from "../types";

/*
  TODO: gestire le label con un enum o qualcosa di simile, in modo che siano tutte elencate qui.
*/
export function useTranslation() {
  const [labels] = useReduxState<Label[]>(reduxStoreConfig.systemLabels);

  const t: (label?: string) => string = (label?: string) => {
    if (labels) {
      const foundLabel = labels.find((l) => l.key === label)?.value;
      if (foundLabel) {
        return foundLabel;
      } else {
        console.log("Missing label: " + label);
        return "Missing label: " + label;
      }
    } else return "Labels not loaded!!!";
  };
  return { t };
}
